module.exports = __webpack_public_path__ + "static/media/ageelementantiwrinklecream.8dc1a07d.png";